import {
    Component,
    OnInit,
    OnDestroy,
    Input,
    ViewChild,
    inject,
} from '@angular/core';
import {DxTreeViewTypes} from 'devextreme-angular/ui/tree-view';
import {DxDrawerModule, DxDrawerTypes} from 'devextreme-angular/ui/drawer';
import {DxScrollViewComponent} from 'devextreme-angular/ui/scroll-view';
import {CommonModule} from '@angular/common';
import {Router, RouterModule, NavigationEnd, Event} from '@angular/router';
import {Subscription} from 'rxjs';

import {ScreenService, AppInfoService, UploadManagerService} from '../../services';
import {SideNavigationMenuComponent, AppHeaderComponent, AppFooterComponent} from '../../components';
import {UploadProgressOverlayComponent} from '../../components/library/upload-progress/upload-progress-overlay.component';

@Component({
    selector: 'app-side-nav-outer-toolbar',
    templateUrl: './side-nav-outer-toolbar.component.html',
    styleUrls: ['./side-nav-outer-toolbar.component.scss'],
    imports: [
        RouterModule,
        SideNavigationMenuComponent,
        DxDrawerModule,
        AppHeaderComponent,
        CommonModule,
        AppFooterComponent,
        UploadProgressOverlayComponent
    ],
})
export class SideNavOuterToolbarComponent implements OnInit, OnDestroy {
    @ViewChild(DxScrollViewComponent, {static: true}) scrollView!: DxScrollViewComponent;

    @Input()
    title!: string;

    private screen = inject(ScreenService);

    private router = inject(Router);

    private uploadManager = inject(UploadManagerService);

    protected appInfo = inject(AppInfoService);

    selectedRoute = '';

    menuOpened!: boolean;

    temporaryMenuOpened = false;

    menuMode: DxDrawerTypes.OpenedStateMode = 'shrink';

    menuRevealMode: DxDrawerTypes.RevealMode = 'expand';

    minMenuSize = 0;

    shaderEnabled = false;

    routerSubscription: Subscription;

    screenSubscription: Subscription;

    constructor() {
        this.routerSubscription = this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.selectedRoute = event.urlAfterRedirects.split('?')[0];
            }
        });
    }

    ngOnInit() {
        this.menuOpened = this.screen.sizes['screen-large'];

        this.screenSubscription = this.screen.changed.subscribe(() => this.updateDrawer());

        this.updateDrawer();

        this.uploadManager.init();
    }

    ngOnDestroy(): void {
        this.routerSubscription.unsubscribe();
        this.screenSubscription.unsubscribe();
    }

    updateDrawer() {
        const isXSmall = this.screen.sizes['screen-x-small'];
        const isLarge = this.screen.sizes['screen-large'];

        this.menuMode = isLarge ? 'shrink' : 'overlap';
        this.menuRevealMode = isXSmall ? 'slide' : 'expand';
        this.minMenuSize = isXSmall ? 0 : 48;
        this.shaderEnabled = !isLarge;
    }

    get hideMenuAfterNavigation() {
        return this.menuMode === 'overlap' || this.temporaryMenuOpened;
    }

    get showMenuAfterClick() {
        return !this.menuOpened;
    }

    async navigationChanged(event: DxTreeViewTypes.ItemClickEvent) {
        const path = (event.itemData as any).path;
        const pointerEvent = event.event;

        if (path && this.menuOpened) {
            await this.router.navigate([path]);

            if (this.hideMenuAfterNavigation) {
                this.temporaryMenuOpened = false;
                this.menuOpened = false;
                pointerEvent?.stopPropagation();
            }
        } else {
            pointerEvent?.preventDefault();
        }
    }

    navigationClick() {
        if (this.showMenuAfterClick) {
            this.temporaryMenuOpened = true;
            this.menuOpened = true;
        }
    }
}
